var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchTeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6517 28.335C23.6502 29.949 21.1046 30.9154 18.3332 30.9154C11.8898 30.9154 6.6665 25.692 6.6665 19.2487C6.6665 12.8054 11.8898 7.58203 18.3332 7.58203C24.7765 7.58203 29.9998 12.8054 29.9998 19.2487C29.9998 22.0201 29.0335 24.5658 27.4194 26.5672L32.9931 32.1408C33.4812 32.629 33.4812 33.4204 32.9931 33.9086C32.5049 34.3968 31.7135 34.3968 31.2253 33.9086L25.6517 28.335ZM27.4998 19.2487C27.4998 24.3113 23.3958 28.4154 18.3332 28.4154C13.2706 28.4154 9.1665 24.3113 9.1665 19.2487C9.1665 14.1861 13.2706 10.082 18.3332 10.082C23.3958 10.082 27.4998 14.1861 27.4998 19.2487Z",
    fill: "#06799B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTeal);
export default __webpack_public_path__ + "static/media/Icon_Search_Teal.f252743eb5ded8ec71c4ccd8d7b763b3.svg";
export { ForwardRef as ReactComponent };